/**
 * INACTIVE — retired with the direct-to-checkout bundle flow. Prospects now
 * start at the labs get-started funnel before purchasing. No template renders
 * the [data-th-get-started-checkout] trigger, and layout/theme.liquid no longer
 * loads this script. Kept for reference only.
 *
 * Get Started bundle: POST /cart/clear.js, then /cart/add.js with multiple lines (subscription + selling plan), redirect to /checkout.
 * Config: #th-get-started-bundle-config (Theme settings via snippets/th-get-started-bundle-config.liquid).
 * Triggers: click on [data-th-get-started-checkout] (Base PDP and get-started landing).
 */
(function () {
  'use strict';

  function getConfig() {
    var el = document.getElementById('th-get-started-bundle-config');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function labelNode(triggerEl) {
    var span = triggerEl.querySelector('span');
    return span || triggerEl;
  }

  function buildItems(config) {
    var welcomeId = parseInt(String(config.welcomeKitVariantId), 10);
    var labsUploadId = parseInt(String(config.labsUploadVariantId), 10);
    var subId = parseInt(String(config.subscriptionVariantId), 10);
    var planNum = config.sellingPlanId ? parseInt(String(config.sellingPlanId), 10) : 0;

    if (!welcomeId || !labsUploadId || !subId) {
      throw new Error('Invalid bundle variant IDs in theme settings.');
    }

    var subscriptionItem = { id: subId, quantity: 1 };
    if (planNum && planNum > 0) {
      subscriptionItem.selling_plan = planNum;
    }

    return [
      { id: welcomeId, quantity: 1 },
      { id: labsUploadId, quantity: 1 },
      subscriptionItem,
    ];
  }

  function setLoading(triggerEl, loading) {
    var node = labelNode(triggerEl);
    if (!triggerEl._thGsOriginalLabel) {
      triggerEl._thGsOriginalLabel = node.textContent;
    }
    if (loading) {
      node.textContent = 'Processing...';
      triggerEl.style.opacity = '0.7';
      triggerEl.style.pointerEvents = 'none';
    } else {
      node.textContent = triggerEl._thGsOriginalLabel;
      triggerEl.style.opacity = '1';
      triggerEl.style.pointerEvents = 'auto';
      delete triggerEl._thGsOriginalLabel;
    }
  }

  async function runCheckout(triggerEl, config) {
    setLoading(triggerEl, true);

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      var items = buildItems(config);
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      });

      if (!response.ok) {
        var errorData = await response.json().catch(function () {
          return {};
        });
        throw new Error(errorData.description || errorData.message || 'Failed to add items to cart');
      }

      window.location.href = '/checkout';
    } catch (error) {
      alert('Error: ' + (error.message || 'There was a problem adding items to your cart. Please try again.'));
      setLoading(triggerEl, false);
    }
  }

  function init() {
    var config = getConfig();
    if (!config || !config.subscriptionVariantId) return;

    document.body.addEventListener('click', function (e) {
      var t = e.target.closest('[data-th-get-started-checkout]');
      if (!t) return;
      e.preventDefault();
      runCheckout(t, config);
    });
  }

  window.THGetStartedCheckout = {
    getConfig: getConfig,
    /** @param {HTMLElement} triggerEl */
    run: function (triggerEl, overrides) {
      var config = overrides || getConfig();
      if (!config) return Promise.reject(new Error('Missing get started bundle config'));
      return runCheckout(triggerEl, config);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
